import { Box, Link } from '@mui/material'
import { styled } from '@mui/material/styles'

export const BoxWrapper = styled(Box)(({ theme }) => ({
  '&.content': {
    backgroundColor: theme.palette.grey[300],
    padding: '8px',
    margin: '15px 0px 8px',
    '& .title': {
      fontSize: '16px',
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      lineHeight: '18px',
      letterSpacing: '0.15px',
      fontWeight: '500',
      marginBottom: 12,
    },
  },
}))

export const NoProperty = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '1rem',
  color: theme.palette.grey[500],
  fontFamily: theme.typography.fontFamily,
}))

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  fontFamily: theme.typography.fontFamily,
}))
